module.exports = __webpack_public_path__ + "img/textiles.14fca61d.png";